import Art from "../files/Categories/1.svg"
import Biography from "../files/Categories/2.svg"
import Business from "../files/Categories/3.svg"
import Children from "../files/Categories/4.svg"
import Classics from "../files/Categories/5.svg"
import Comedy from "../files/Categories/6.svg"
import Comics from "../files/Categories/7.svg"
import Cookbook from "../files/Categories/8.svg"
import Crime from "../files/Categories/9.svg"
import Fiction from "../files/Categories/10.svg"
import Historical from "../files/Categories/11.svg"
import History from "../files/Categories/12.svg"
import Horror from "../files/Categories/13.svg"
import Humor from "../files/Categories/14.svg"
import Memoir from "../files/Categories/15.svg"
import Music from "../files/Categories/16.svg"
import Mystery from "../files/Categories/17.svg"
import NonFiction from "../files/Categories/18.svg"
import Paranormal from "../files/Categories/19.svg"
import Philosophy from "../files/Categories/20.svg"
import Poetry from "../files/Categories/21.svg"
import Psychology from "../files/Categories/22.svg"
import Religion from "../files/Categories/23.svg"
import Romance from "../files/Categories/24.svg"
import Science from "../files/Categories/25.svg"
import SciFi from "../files/Categories/26.svg"
import Self from "../files/Categories/27.svg"
import Suspense from "../files/Categories/28.svg"
import Spirituality from "../files/Categories/29.svg"
import Sports from "../files/Categories/30.svg"
import Thriller from "../files/Categories/31.svg"
import Travel from "../files/Categories/32.svg"
import Young from "../files/Categories/33.svg"
import short from "../files/Categories/37.svg"
import action from "../files/Categories/35.svg"
import adventure from "../files/Categories/36.svg"

const genresData = [
    { id: "18", img: NonFiction, genre: "Non-Fiction" },
    
  { id: "31", img: Thriller, genre: "Thriller" },
  { id: "27", img: Self, genre: "Self-Help" },
  { id: "10", img: Fiction, genre: "Fiction" },
  { id: "11", img: Historical, genre: "Historical Fiction" },
  { id: "25", img: Science, genre: "Science" },
  { id: "26", img: SciFi, genre: "Science Fiction" },
  { id: "19", img: Paranormal, genre: "Paranormal" },
  { id: "28", img: Suspense, genre: "Suspense" },
  { id: "13", img: Horror, genre: "Horror" },
  { id: "2", img: Biography, genre: "Biography" },
  { id: "9", img: Crime, genre: "Crime" },
  { id: "8", img: Cookbook, genre: "Cookbooks" },
  { id: "17", img: Mystery, genre: "Mystery" },
  { id: "12", img: History, genre: "History" },
  { id: "14", img: Humor, genre: "Humor" },
  { id: "24", img: Romance, genre: "Romance" },
  { id: "29", img: Spirituality, genre: "Spirituality" },
  { id: "30", img: Sports, genre: "Sports" },
  { id: "15", img: Memoir, genre: "Memoir" },
  { id: "16", img: Music, genre: "Music" },
  { id: "1", img: Art, genre: "Art" },
  { id: "34", img: short, genre: "Short Story"},
  { id: "3", img: Business, genre: "Business" },
  { id: "4", img: Children, genre: "Children's" },
  { id: "5", img: Classics, genre: "Classics" },
  { id: "6", img: Comedy, genre: "Comedy" },
  { id: "7", img: Comics, genre: "Comics" },
  { id: "20", img: Philosophy, genre: "Philosophy" },
  { id: "21", img: Poetry, genre: "Poetry" },
  { id: "22", img: Psychology, genre: "Psychology" },
  { id: "23", img: Religion, genre: "Religion" },
  { id: "35", img: action, genre: "Action" },
  { id: "36", img: adventure, genre: "Adventure" },
  { id: "32", img: Travel, genre: "Travel" },
  { id: "33", img: Young, genre: "Young Adult" },
];

export default genresData;
